import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Navigate } from "react-router-dom";
import WarehouseInMiddleware from "../../../../middleware/modules/warehouse/warehouse-in";
import Form from "../../../../components/modules/warehouse/warehouse-in/form-view";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, warehousein }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: warehousein.isProcessing,
  isError: warehousein.isError,
  errorMessage: warehousein.errorMessage,
  dataUpdate: warehousein.single,
  isSuccess: warehousein.isSuccess,
  isReset: warehousein.isReset,
  isNewRecord: warehousein.isNewRecord,
  onSubmit: warehousein.onSubmit,
  helperWarehouseIn: warehousein.WHInHelperFull,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getHelperFull: (date) => WarehouseInMiddleware.getHelperFull(date),
      getStore: () => StoresMiddleware.getHelper(),
      closeModal: () => WarehouseInMiddleware.reset(),
      new: (data, search) => WarehouseInMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
        WarehouseInMiddleware.beforeSaveUpdate(id, type, search),
    },
    dispatch
  );
};
class FormContainerView extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: {},
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.changeSelect = this.changeSelect.bind(this);
    this.close = this.close.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.id);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if (isNewRecord) {
      this.props.new(form, search);
    } else {
      this.props.update(dataUpdate.id, form, search);
    }
  }

  changeSelect(type, value = null) {
    const params = { id: value };
    switch (type) {
      case "idBranch":
        this.props.getStore(params);
        break;
      default:
        break;
    }
  }

  render() {
    const {
      helperWarehouseIn,
      branchList,
      storeList,
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      isProcessing,
      isError,
      errorMessage,
    } = this.props;
    return (
      <>
        <Modal show={showModal} size={"xl"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            <Form
              isNewRecord={isNewRecord}
              isReset={isReset}
              data={dataUpdate}
              isProcessing={isProcessing}
              isError={isError}
              errorMessage={errorMessage}
              ref={this.form}
              storeList={storeList}
              branchList={branchList}
              helperWarehouseIn={helperWarehouseIn}
              changeSelect={this.changeSelect}
            />
          </Modal.Body>
          <Modal.Footer className={"justify-content-between"}>
           
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainerView);
